import * as React from "react";
import classnames from "classnames";

import { toHumanRelativeDateFromNow } from "lib/utils/relative_time";
import { TENDER_STAGE_LABELS } from "./landing_types";

import css from "./RecordStage.module.scss";

const stageColours = {
  STALE_PRE_TENDER: "gold",
  PRE_TENDER: "yellow",
  OPEN: "green",
  CLOSED: "red",
  AWARDED: "blue",
} as const;

function RecordStage({
  record,
  className,
  hideAssociatedDate,
}: {
  record: {
    stage: keyof typeof stageColours;
    close_date?: string | null;
    expiry_date?: string | null;
  };
  className?: string;
  hideAssociatedDate?: boolean;
}): JSX.Element {
  const descriptor = React.useMemo(() => {
    if (hideAssociatedDate) return null;

    switch (record.stage) {
      case "OPEN": {
        if (!record.close_date) break;

        return (
          <span className={css.descriptor}>
            closing{" "}
            <time dateTime={record.close_date}>
              {toHumanRelativeDateFromNow(record.close_date)}
            </time>
          </span>
        );
      }
      case "AWARDED":
        if (!record.expiry_date) break;

        return (
          <span className={css.descriptor}>
            expiring{" "}
            <time dateTime={record.expiry_date}>
              {toHumanRelativeDateFromNow(record.expiry_date)}
            </time>
          </span>
        );
    }

    return null;
  }, [record.stage, record.expiry_date, record.close_date, hideAssociatedDate]);

  return (
    <span
      className={classnames(
        className,
        css.stage,
        css[`${stageColours[record.stage]}`] ?? css["unknown"],
      )}
    >
      <span
        className={classnames(
          css.dot,
          css[`dot-${stageColours[record.stage]}`] ?? css["dot-unknown"],
        )}
      />{" "}
      {TENDER_STAGE_LABELS[record.stage] ?? "Unknown"}
      {descriptor}
    </span>
  );
}
export default RecordStage;
